import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import { SC } from "./graphql/query";
import { useContainer } from "./hooks/useContainer";
import styles from "./styles.module.css";
type BerthSelectorProps = {
  open: boolean;
  isNullable?: boolean;
  cbFunc: (berthId: string) => void;
};
export const BerthSelector = SC<BerthSelectorProps>(({
  unloadingDocks = [],
  open,
  isNullable = false,
  cbFunc
}) => {
  const {
    sortedUnloadingDocks,
    onClickCard,
    disabled
  } = useContainer({
    unloadingDocks,
    cbFunc
  });
  return <Modal open={open}>
        <Box display="flex" justifyContent="center" alignItems="center" width="100vw" height="100vh" p="108px 224px">
          <Paper className={styles.paper}>
            <Grid container spacing={2} justifyContent="left" className={styles.gridContainer}>
              {[...(isNullable ? [{
            id: "",
            name: "指定なし"
          }] : []), ...sortedUnloadingDocks].map(berth => <Grid size={4} key={berth.id}>
                    <Card>
                      <CardActionArea className={styles.card} onClick={() => onClickCard(berth.id)} disabled={disabled}>
                        {berth.name}
                      </CardActionArea>
                    </Card>
                  </Grid>)}
            </Grid>
          </Paper>
        </Box>
      </Modal>;
});